export const SHOW_SETTINGS_EVENT = 'show-settings';

// export default function useSettingsDialog() {
//     return  {
//         'SHOW_SETTINGS_EVENT': SHOW_SETTINGS_EVENT
//     };
// };
